import { Products } from 'merchandise-lib/constants/Product';
import { VALID_CUSTOMER_PLATFORM_BUNDLE_SKU_CATEGORY_NAMES, VALID_PAID_PRODUCT_LEVELS, VALID_PRODUCT_LEVELS, VALID_PRODUCT_LINES, VALID_QUANTITY_NAMES, VALID_QUANTITY_PACK_API_NAMES, VALID_SKU_CATEGORY_NAMES, VALID_TRACKING_SOURCES, VALID_TTS_PURCHASE_MOTIONS } from './validTypeValues';
const ApiNamesSet = new Set(Object.values(Products));
export const isValidApiName = apiName => {
  return apiName !== null && apiName !== undefined && typeof apiName === 'string' && (ApiNamesSet.has(apiName) || apiName === 'crm-suite-free-bundle');
};
export function assertIsValidApiName(apiName) {
  if (!isValidApiName(apiName)) {
    throw new Error(`Invalid ApiName: ${String(apiName)}`);
  }
}
export const isValidProductLine = productLine => {
  return productLine !== null && productLine !== undefined && typeof productLine === 'string' && VALID_PRODUCT_LINES.has(productLine);
};
export const isValidProductLevel = level => {
  return level !== null && level !== undefined && typeof level === 'string' && VALID_PRODUCT_LEVELS.has(level);
};
export const isValidPaidProductLevel = level => {
  return level !== null && level !== undefined && typeof level === 'string' && VALID_PAID_PRODUCT_LEVELS.has(level);
};
export const isValidTier = value => {
  return value !== null && value !== undefined && typeof value === 'string' && value.toUpperCase() === 'ENTERPRISE';
};
export const isValidSkuCategoryName = name => {
  return typeof name === 'string' && VALID_SKU_CATEGORY_NAMES.has(name);
};
export const isValidCustomerPlatformBundleSkuCategoryName = name => {
  return typeof name === 'string' && VALID_CUSTOMER_PLATFORM_BUNDLE_SKU_CATEGORY_NAMES.has(name);
};
export const isTrackingSource = source => {
  return typeof source === 'string' && VALID_TRACKING_SOURCES.has(source);
};
export const isTTSPurchaseMotion = purchaseMotion => {
  return typeof purchaseMotion === 'string' && VALID_TTS_PURCHASE_MOTIONS.has(purchaseMotion);
};
export const isValidQuantityName = quantityName => {
  return typeof quantityName === 'string' && VALID_QUANTITY_NAMES.has(quantityName);
};
export const isValidQuantityPackApiName = quantityPackApiName => {
  return typeof quantityPackApiName === 'string' && VALID_QUANTITY_PACK_API_NAMES.has(quantityPackApiName);
};
export function assertIsValidQuantityPackApiName(quantityPackApiName) {
  if (!isValidQuantityPackApiName(quantityPackApiName)) {
    throw new Error(`Invalid QuantityPackApiName: ${String(quantityPackApiName)}`);
  }
}
export function isQueryParamTerm(value) {
  return value !== undefined && value !== null && (value === 'ANNUAL' || value === 'MONTHLY');
}
export function isQueryParamTermLegacy(value) {
  return value !== undefined && value !== null && (value === 'annual' || value === 'monthly');
}
export const isValidPurchaseTerm = term => {
  return term !== undefined && term !== null && (term === 'ANNUAL' || term === 'MONTHLY');
};
export const isValidSku = sku => {
  return typeof sku === 'object' && sku !== null && 'skuType' in sku;
};
export const isQuantityPackDetails = sku => {
  return isValidSku(sku) && sku.skuType === 'QUANTITY_PACK';
};
export function assertIsQuantityPackDetails(sku) {
  if (!isQuantityPackDetails(sku)) {
    throw new Error(`SKU is not of type QuantityPackDetails`);
  }
}
export const isProductVersion = sku => {
  return isValidSku(sku) && sku.skuType === 'PRODUCT_VERSION';
};
export function assertIsProductVersion(sku) {
  if (!isProductVersion(sku)) {
    throw new Error(`SKU is not of type ProductVersion`);
  }
}
export const isCoreSeatsApiName = apiName => {
  return [Products.CORE_SEATS_INCLUDED_STARTER, Products.CORE_SEATS_STARTER, Products.CORE_SEATS_PROFESSIONAL, Products.CORE_SEATS_ENTERPRISE].includes(apiName);
};

// TODO: Use BundleType that's generated instead of using SSAPI
const BUNDLE_TYPES = new Set(['CRM_SUITE', 'MARKETING_PLUS_SUITE']);
export const isValidBundleType = bundleType => {
  return typeof bundleType === 'string' && BUNDLE_TYPES.has(bundleType);
};